// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import AuthProvider, { AuthContext } from './AuthProvider';

import HomePage from './HomePage';
// ⬇️ RegisterPage borttagen
// import RegisterPage from './RegisterPage';
import LoginPage from './LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import NewCasePage from './pages/NewCasePage';
import DocumentsPage from './pages/DocumentsPage';
import DocumentDetailPage from './pages/DocumentDetailPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import SupportPage from './pages/SupportPage';
import WasteCodesPage from './pages/WasteCodesPage';
import ProfilePage from './pages/ProfilePage';
import UserManagementPage from './pages/UserManagementPage';
import AddCompanyPage from './pages/AddCompanyPage';
// ❌ ApiKeyPage import borttagen
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

// Trial
import TrialExpiredPage from './pages/TrialExpiredPage';
import RequireTrialActive from './components/RequireTrialActive';

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (e) => {
    // eslint-disable-next-line no-console
    console.error('[UNHANDLED REJECTION]', e.reason);
  });
  window.addEventListener('error', (e) => {
    // eslint-disable-next-line no-console
    console.error('[UNCAUGHT ERROR]', e.error || e.message);
  });
}

function PrivateRoute({ children }) {
  const { currentCompany } = React.useContext(AuthContext);
  return currentCompany ? children : <Navigate to="/login" replace />;
}

function AuthGate({ children, redirectIfAuthed = false }) {
  const { currentCompany } = React.useContext(AuthContext);
  if (redirectIfAuthed && currentCompany) return <Navigate to="/dashboard" replace />;
  return children;
}

function FallbackByAuth() {
  const { currentCompany } = React.useContext(AuthContext);
  return <Navigate to={currentCompany ? '/dashboard' : '/login'} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <div className="app-container">
        <div className="mobile-frame">
          <ErrorBoundary>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/"
                  element={
                    <AuthGate redirectIfAuthed>
                      <HomePage />
                    </AuthGate>
                  }
                />

                {/* ⬇️ Register-route borttagen */}
                {/* <Route
                  path="/register"
                  element={
                    <AuthGate redirectIfAuthed>
                      <RegisterPage />
                    </AuthGate>
                  }
                /> */}

                <Route
                  path="/login"
                  element={
                    <AuthGate redirectIfAuthed>
                      <LoginPage />
                    </AuthGate>
                  }
                />

                {/* Publika auth-sidor */}
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />

                {/* Privata sidor */}
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <RequireTrialActive>
                        <DashboardPage />
                      </RequireTrialActive>
                    </PrivateRoute>
                  }
                />
                <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
                <Route path="/new-case" element={<PrivateRoute><NewCasePage /></PrivateRoute>} />
                <Route path="/documents" element={<PrivateRoute><DocumentsPage /></PrivateRoute>} />
                <Route path="/documents/:id" element={<PrivateRoute><DocumentDetailPage /></PrivateRoute>} />
                <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
                <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
                <Route path="/support" element={<PrivateRoute><SupportPage /></PrivateRoute>} />
                <Route path="/waste-codes" element={<PrivateRoute><WasteCodesPage /></PrivateRoute>} />
                <Route path="/user-management" element={<PrivateRoute><UserManagementPage /></PrivateRoute>} />
                <Route path="/add-company" element={<PrivateRoute><AddCompanyPage /></PrivateRoute>} />

                {/* Trial-sida */}
                <Route
                  path="/trial-expired"
                  element={
                    <PrivateRoute>
                      <TrialExpiredPage />
                    </PrivateRoute>
                  }
                />

                {/* Fallback */}
                <Route path="*" element={<FallbackByAuth />} />
              </Routes>
            </BrowserRouter>
          </ErrorBoundary>
        </div>
      </div>
    </AuthProvider>
  );
}